import React from "react";
import { FetchMovies } from "../components/FetchMovies";

export const Home = () => (
  <>
    <FetchMovies />
  </>
);
